module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column"
  }, _vm._l((_vm.features), function(feature, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex"
    }, [_c('p', {
      staticClass: "title-counter"
    }, [_vm._v(_vm._s(feature.name))]), _vm._v(" "), _c('div', {
      staticClass: "d-flex wrap"
    }, _vm._l((feature.values), function(value, indexValue) {
      return _c('button', {
        key: indexValue,
        staticClass: "item-color",
        class: {
          'active': value.active, 'possible': value.possible
        },
        on: {
          "click": function($event) {
            _vm.$emit('select', index, indexValue)
          }
        }
      }, [_vm._v(_vm._s(value.name))])
    }))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-613d1528","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/features.vue
// module id = 1126
// module chunks = 1